import { render } from "./EfaaS.vue?vue&type=template&id=f349b510"
import script from "./EfaaS.vue?vue&type=script&lang=js"
export * from "./EfaaS.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__